import gql from 'graphql-tag';

export const GET_CHANNELS_LIST = gql`
  query ($licenseId: ID, $siteini: String){
    channelList(license_id: $licenseId, siteini: $siteini) {
      id
      xmltv_id
      identifier
      ungrabbed
      siteini {
        site
        country
      }
      license {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/channels/list.js